import React, { useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { createContactLinks, updateContactLinks } from "api/index";
import { Label } from "@progress/kendo-react-labels";
import { toast } from "react-toastify";
import SubmitButton from "components/common/SubmitButton";

const validateForm = (values) => {
  const errors = {};
  if (!values.categoryName?.trim())
    errors.categoryName = "Category Name is required";
  return errors;
};

const ContactLinkTypeModal = (props) => {
  const ADD_NEW = !props.data || !props.data.contactCategoryId;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);

  const handleSubmit = async (formValues) => {
    setIsSubmitting(true);
    try {
      if (ADD_NEW) {
        const payload = {
          active: true,
          showRef1: true,
          showRef2: true,
          showRef3: true,
          ...formValues,
        };
        const { status } = await createContactLinks(payload);
        if (status === 200 || status === 201) {
          toast.success("Contact Category added");
          props.onClose?.(true);
        } else {
          toast.error("Error occurred while adding");
          props.onClose?.(false);
        }
      } else {
        const contactCategoryId = props.data.contactCategoryId;
        const { status } = await updateContactLinks(contactCategoryId, {
          ...formValues,
        });
        if (status === 200) {
          props.onClose?.(true);
          toast.success(
            `Contact Category '${props?.data?.categoryName}' has been updated`
          );
        } else {
          props.onClose?.(false);
          toast.error("Error occurred while updating");
        }
      }
    } catch (e) {
      props.onClose?.(false);
      toast.error(
        ADD_NEW
          ? "Error occurred while adding"
          : "Error occurred while updating"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      title={
        ADD_NEW ? "Add Contact Category" : `Edit ${props?.data?.categoryName}`
      }
      onClose={() => props.onClose?.(false)}
      width={600}
    >
      <>
        <Form
          initialValues={
            ADD_NEW
              ? { active: true, showRef1: true, showRef2: true, showRef3: true }
              : props?.data
          }
          validator={validateForm}
          onSubmit={handleSubmit}
          render={(formRenderProps) => (
            <>
              <FormElement>
                <fieldset className="p-3 ps-5">
                  <div className="mb-3">
                    <Label className="label mt-1 mb-2 w-100">
                      Category Name&nbsp;
                    </Label>
                    <Field
                      name="categoryName"
                      component={Input}
                      style={{ width: "268px" }}
                      maxLength={50}
                    />
                    {submitAttempted &&
                      formRenderProps.errors?.categoryName && (
                        <div className="fs-sm my-1 text-danger">
                          <i>{formRenderProps.errors.categoryName}</i>
                        </div>
                      )}
                  </div>
                  <div className="mb-3">
                    <div>
                      <Label className="label mt-1 mb-2 w-100">
                        Category Details&nbsp;
                      </Label>
                      <Field
                        name="categoryDetails"
                        component={Input}
                        style={{ width: "268px" }}
                        maxLength={50}
                      />
                    </div>
                  </div>
                  <div className="mb-3 d-flex align-items-center gap-5">
                    <div>
                      <Label className="label mt-1 mb-2 w-100">
                        Label for Reference 1&nbsp;
                      </Label>
                      <Field
                        name="labelForRef1"
                        style={{ width: "268px" }}
                        component={Input}
                        maxLength={50}
                      />
                    </div>
                    <div className="mt-4">
                      <Field
                        defaultChecked={true}
                        name="showRef1"
                        component={Checkbox}
                        label="Show Reference 1"
                      />
                    </div>
                  </div>
                  <div className="mb-3 d-flex align-items-center gap-5">
                    <div>
                      <Label className="label mt-1 mb-2 w-100">
                        Label for Reference 2&nbsp;
                      </Label>
                      <Field
                        name="labelForRef2"
                        style={{ width: "268px" }}
                        component={Input}
                        maxLength={50}
                      />
                    </div>
                    <div className="mt-4">
                      <Field
                        defaultChecked={true}
                        name="showRef2"
                        component={Checkbox}
                        label="Show Reference 2"
                      />
                    </div>
                  </div>
                  <div className="mb-3 d-flex align-items-center gap-5">
                    <div>
                      <Label className="label mt-1 mb-2 w-100">
                        Label for Reference 3&nbsp;
                      </Label>
                      <Field
                        name="labelForRef3"
                        style={{ width: "268px" }}
                        component={Input}
                        maxLength={50}
                      />
                    </div>
                    <div className="mt-4">
                      <Field
                        defaultChecked={true}
                        name="showRef3"
                        component={Checkbox}
                        label="Show Reference 3"
                      />
                    </div>
                  </div>
                  <Field
                    defaultChecked={true}
                    name="active"
                    component={Checkbox}
                    label="Active"
                  />
                </fieldset>
              </FormElement>

              <div className="dialog-footer">
                <button
                  className="bgBtnSecondary common-btn me-2"
                  onClick={() => props.onClose?.(false)}
                  type="button"
                >
                  Cancel
                </button>
                <SubmitButton
                  className="common-btn me-3"
                  onClick={() => {
                    setSubmitAttempted(true);
                    formRenderProps.onSubmit();
                  }}
                  isLoading={isSubmitting}
                  disabled={!formRenderProps.allowSubmit || isSubmitting}
                >
                  {ADD_NEW ? "Add" : "Update"}
                </SubmitButton>
              </div>
            </>
          )}
        />
      </>
    </Dialog>
  );
};

export default ContactLinkTypeModal;
